import { c as _c } from "react/compiler-runtime";
import { create } from 'zustand';
import useMobileLayout from '@/hooks/use-mobile-layout';
type MobileNavigationStore = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
};
const useMobileNavigationStore = create<MobileNavigationStore>(set => ({
  isOpen: false,
  setOpen: isOpen => set({
    isOpen
  })
}));
const useMobileNavigation = () => {
  const $ = _c(3);
  const isMobile = useMobileLayout();
  const isOpen = useMobileNavigationStore(_temp);
  const setOpen = useMobileNavigationStore(_temp2);
  const t0 = isMobile && isOpen;
  let t1;
  if ($[0] !== setOpen || $[1] !== t0) {
    t1 = {
      isOpen: t0,
      setOpen
    };
    $[0] = setOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useMobileNavigation;
function _temp(state) {
  return state.isOpen;
}
function _temp2(state_0) {
  return state_0.setOpen;
}